"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _theme = _interopRequireDefault(require("../../../theme/theme.styles"));

var _Column = require("./Column.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Column = function Column(_ref) {
  var children = _ref.children,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 'start' : _ref$spacing,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? 'start' : _ref$alignment,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 'auto' : _ref$height,
      _ref$dataTestId = _ref.dataTestId,
      dataTestId = _ref$dataTestId === void 0 ? 'occ-column' : _ref$dataTestId;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_theme["default"], null), /*#__PURE__*/_react["default"].createElement(_Column.Occ_Column, {
    "data-test-id": dataTestId,
    spacing: spacing,
    alignment: alignment,
    height: height
  }, children));
};

var _default = Column;
exports["default"] = _default;